import { render } from "./JoinPublicationSignUp.vue.js?vue&type=template&id=071699ba!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationSignUp.vue?vue&type=template&id=071699ba"
import script from "./JoinPublicationSignUp.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationSignUp.vue?vue&type=script&lang=js"
export * from "./JoinPublicationSignUp.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationSignUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/login-signup-page/join-publication/JoinPublicationSignUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "071699ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('071699ba', __exports__)) {
    api.reload('071699ba', __exports__)
  }
  
  module.hot.accept("./JoinPublicationSignUp.vue.js?vue&type=template&id=071699ba!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationSignUp.vue?vue&type=template&id=071699ba", () => {
    api.rerender('071699ba', render)
  })

}


export default __exports__